const resolveVariablesInMessage = (
  message: string,
  variables?: Record<string, string>
): string => {
  if (!variables) return message;

  return message.replace(/{{(.*?)}}/g, (_match, variableName) => {
    return variables[variableName.trim()] || `{{${variableName}}}`;
  });
};

export default resolveVariablesInMessage;
